<template>
    <div class="login-container">
        <form class="login-form" @submit.prevent="login">
            <h2>Login</h2>

            <div class="form-group">
                <label for="email">E-Mail</label>
                <input
                    id="email"
                    v-model="email"
                    type="text"
                    placeholder="text"
                    required
                >
            </div>

            <div class="form-group">
                <label for="password">Passwort</label>
                <input
                    id="password"
                    v-model="password"
                    type="password"
                    placeholder="Passwort"
                    required
                >
            </div>

            <p v-if="errorMessage" class="error">
                {{ errorMessage }}
            </p>

            <button type="submit" :disabled="loading">
                {{ loading ? 'Einloggen...' : 'Einloggen' }}
            </button>
        </form>
    </div>
</template>

<script setup>
import { ref } from 'vue'

const email = ref('')
const password = ref('')
const errorMessage = ref('')
const loading = ref(false)



function getCookie(name) {
    const cookies = document.cookie.split('; ')

    const cookie = cookies.find(row =>
        row.startsWith(name + '=')
    )

    if (!cookie) {
        return null
    }

    return decodeURIComponent(
        cookie.substring(name.length + 1)
    )
}


async function login() {
    loading.value = true
    errorMessage.value = ''

    const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    try {

        // 3. Login durchführen
        const response = await fetch("/login", {
            method: 'POST',

            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrf,
                'Accept': 'application/json',

            },

            body: JSON.stringify({
                email: email.value,
                password: password.value
            })
        })


        const data = await response.json()


        if (!response.ok) {
            errorMessage.value =
                data.message ?? 'Login fehlgeschlagen'

            return
        }


        console.log('Login erfolgreich')
        console.log(data)

    } catch (error) {

        console.error(error)

        errorMessage.value =
            'Verbindung zum Server fehlgeschlagen'

    } finally {

        loading.value = false

    }
}
</script>


<style scoped>
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;

    min-height: 100vh;

    background: #f5f5f5;
}


.login-form {
    width: 350px;

    padding: 30px;

    background: white;

    border: 1px solid #ddd;
    border-radius: 6px;
}


.login-form h2 {
    margin-top: 0;
    margin-bottom: 25px;

    text-align: center;
}


.form-group {
    display: flex;
    flex-direction: column;

    margin-bottom: 15px;
}


.form-group label {
    margin-bottom: 5px;

    font-size: 14px;
}


.form-group input {
    padding: 10px;

    border: 1px solid #ccc;
    border-radius: 4px;

    font-size: 15px;
}


.form-group input:focus {
    outline: none;
    border-color: #777;
}


button {
    width: 100%;

    padding: 10px;

    border: none;
    border-radius: 4px;

    background: #333;
    color: white;

    cursor: pointer;
}


button:hover {
    background: #555;
}


button:disabled {
    opacity: 0.6;
    cursor: default;
}


.error {
    color: #c00;

    margin-bottom: 15px;

    font-size: 14px;
}
</style>
